import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';
import { restEndPoints } from '../../app.constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map, of } from 'rxjs';
import { DateConverterService } from '../../helpers/date-converter.service';
import { IReviewCountResponse, IReviewCounts, IReviewGridData, IReviewGridDataResponse } from './review.models';

@Injectable({
    providedIn: 'root'
})
export class ReviewsService {

    baseUrl = environment.apiHost;
    authToken: string | null = '';

    constructor(private httpClient: HttpClient,
        private dateConverterService: DateConverterService) {
    }

    // Method to get category counts with query parameters and headers
    getReviewsCounts(body: any): Observable<IReviewCounts> {
        const payload = {
            CategoryIds: body.CategoryIds,
            StoreIds: body.StoreIds,
            startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(body.startDate),
            endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(body.endDate, true),
            companyId: body.companyId
        }
        const url = `${this.baseUrl}${restEndPoints.reviews.getReviewData}`;

        // Make the GET request with headers and query params
        return this.httpClient.post<any>(url, payload).pipe(
            map((response: IReviewCountResponse) => {
                // Handle the response, extract value if no error
                if (!response.isError) {
                    return response.value;
                } else {
                    return {} as IReviewCounts; // Return an empty object of type IReviewCounts
                }
            })
        );
    }

    getReviewGridData(body: any): Observable<IReviewGridDataResponse> {
        const payload = {
            CategoryIds: body.CategoryIds,
            StoreIds: body.StoreIds,
            startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(body.startDate),
            endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(body.endDate, true),
            companyId: body.companyId
        }
        const params = {
            pageOffset: body.pageOffset,
            pageSize: body.pageSize,
            columnName: body.columnName ,
            sortOrder: body.sortOrder
        }
        if (!payload.CategoryIds || !payload.startDate || !payload.endDate || !payload.companyId || !payload.StoreIds) {
            return of();
        }
        const url = `${this.baseUrl}${restEndPoints.reviews.getGridReviewDetails}`;
        // Set up query params
        let httpParams = new HttpParams();

        // Check and append parameters
        if (params.pageOffset) {
            httpParams = httpParams.append('pageOffset', params.pageOffset);
        }

        if (params.pageSize) {
            httpParams = httpParams.append('pageSize', params.pageSize);
        }

        // Make the GET request with headers and query params
        return this.httpClient.post<any>(url, payload, { params: params })
    }

    getReviewGridDataCount(params: any): Observable<any> {
        const payload = {
            CategoryIds: params.CategoryIds,
            StoreIds: params.StoreIds,
            startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(params.startDate),
            endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(params.endDate, true),
            companyId: params.companyId,
            pageOffset: params.pageOffset,
            pageSize: params.pageSize
        }
        if (!payload.CategoryIds || !payload.startDate || !payload.endDate || !payload.companyId || !payload.StoreIds) {
            return of(false);
        }
        const url = `${this.baseUrl}${restEndPoints.reviews.getReviewDataCount}`;

        // Make the GET request with headers and query params
        return this.httpClient.post<any>(url, payload).pipe(
            map((response: any) => {
                // Handle the response, extract value if no error
                if (!response.isError) {
                    return response.value;
                } else {
                    return;
                }
            })
        );
    }

    getPercentileOfReviewByGrouped(params: any): Observable<any> {
        const payload = {
            CategoryIds: params.categoryIds,
            StoreIds: params.StoreIds,
            startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(params.startDate),
            endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(params.endDate, true),
            companyId: params.companyId
        }
        if (!payload.CategoryIds || !payload.startDate || !payload.endDate || !payload.companyId || !payload.StoreIds) {
            return of(false);
        }
        const url = `${this.baseUrl}${restEndPoints.reviews.getPercentileOfReviewByGrouped}`;
        // Set up query params
        let httpParams = new HttpParams();

        // Make the GET request with headers and query params
        return this.httpClient.post(url, payload).pipe(
            map((response: any) => {
                // Handle the response, extract value if no error
                if (!response.isError) {
                    return response.value;
                } else {
                    return
                }
            })
        );
    }
}
